import http from "../http-common";

class AuditAccesService {
    listAuditAcces(data) {
        return http.get("/audit/list", data);
    }
    existUsuariAuditat(idUsuari) {
        return http.get("/audit/"+idUsuari, {});
    }
}

export default new AuditAccesService();